import { routeTo } from "../../../Components/CustomHooks/routeChange";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { TrainTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";

export class BackToBookingClickAction extends BaseAction<void, {
    bookingId: string,
    route: string
}> {
    override async run(): Promise<void> {
        try {
            const { bookingId, route } = this.params!;
            updateRecoilState("selectedBookingIdForBookReturnJourneyAtom", bookingId);
            updateRecoilState("trainTypeAtom", TrainTypeEnum.outbound);
            routeTo(route);
        } catch (error) {
            console.error("Error during back to booking click action:", error);
        }
    }
}

export const backToBookingClickAction = new BackToBookingClickAction();